import { Error } from '@/api/Error'

export const checkError = (context, error) => {
  // TODO gérer les erreurs au niveau du store
  console.dir(error)
}
